<div class="main-container">
  <div class="main-content">
    <!-- Category cards moved to sidebar submenu -->

    <div class="list-header">
      <h2>List Of Connections</h2>
      <!-- <div class="header-actions" *ngIf="!connectionKey && !profileKey">
        <div class="country-selector" (click)="addressBook()">
          <i class="fa fa-address-book" aria-hidden="true"></i>
          <span>Address Book</span>
        </div>
        <button class="add-new-btn" mat-raised-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
          <span class="btn-text">Add New</span>
          <i class="material-icons expand-icon">{{ menuTrigger.menuOpen ? 'expand_less' : 'expand_more' }}</i>
        </button>
        <mat-menu #menu="matMenu">
          <button class="actionBtn" *ngFor="let option of dropdownOptions" mat-menu-item (click)="option.action()">
            <i *ngIf="option.iconType === 'fa'" [ngClass]="option.icon" aria-hidden="true"></i>&nbsp;
            <span>{{ option.label }}</span>
          </button>
        </mat-menu>
      </div> -->
    </div>

    <!-- List Section -->
    <div class="document-list" *ngIf="!connectionKey && !profileKey"
      [class.list-mode]="viewMode === 'list'">
      <div class="search-section">
        <div class="search-container">
          <i class="material-icons">search</i>
          <input class="search-text" type="text" placeholder="Search for Connection..." [(ngModel)]="searchQuery">
        </div>

        <!-- Sort & view -->
        <div class="view-options">
          <button class="sort-btn" mat-raised-button [matMenuTriggerFor]="sortMenu">
            <i class="material-icons">sort</i>
          </button>

          <mat-menu #sortMenu="matMenu">
            <button *ngFor="let option of sortConnections" mat-menu-item (click)="option.action()">
              <mat-icon>{{ option.icon }}</mat-icon>
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>

          <button class="view-btn" (click)="toggleView()">
            <i class="material-icons">{{ viewMode === 'grid' ? 'grid_view' : 'view_list' }}</i>
          </button>
        </div>
        <!-- Sort & view -->
      </div>

      <!-- Display Contacts -->
      <ng-container *ngIf="list.length > 0; else emptyState">
        <!-- Show Contact Cards -->
<div *ngIf="viewMode === 'grid'" class="contact-cards-container2">
  <div class="contact-card2" 
       *ngFor="let contact of list | filter:searchQuery"
       [class.disabled]="contact.status !== 'active' && contact.status !== 'accepted_by_consumer'"
       (click)="contact.status === 'active' || contact.status === 'accepted_by_consumer' ? profilePage(contact) : null">

    <!-- Status Badge -->

    <!-- Action Icons -->
    <div class="card-top-actions" 
         *ngIf="contact.status === 'active' || contact.status === 'accepted_by_consumer'">
      <i class="far fa-comment-dots icon-btn-top"
         (click)="goChatConnection($event, contact)"
         [class.inactive-icon]="isLawyerInactive(contact)"
         [matTooltip]="isLawyerInactive(contact) ? chatUnavailableMsg(contact) : 'Chat'"></i>
      <i class="far fa-share-square icon-btn-top"
         (click)="goShareConnection($event, contact)"
         [class.inactive-icon]="isLawyerInactive(contact)"
         [matTooltip]="isLawyerInactive(contact) ? sharingDisabledMsg(contact) : 'Share'"></i>
    </div>

    <!-- Avatar -->
    <div class="avatar2" *ngIf="!contact.profile_url">
      {{ contact.business_name?.charAt(0).toUpperCase() }}
    </div>
    <img *ngIf="contact.profile_url" [src]="contact.profile_url" class="profile-img" alt="Profile"
         (error)="contact.profile_url = null" />

    <!-- Details -->
    <div class="contact-details2">
      <h4>{{ contact.business_name }}</h4>
      <p>{{ contact.email || '---' }}</p>
    </div>

    <!-- Action Button -->
    <div class="status-row" *ngIf="!contact.isaccepted">
      <button *ngIf="contact.canAccept && !contact.isaccepted" 
              class="status-accept"
              (click)="acceptRequest(contact.id, contact.biztype); $event.stopPropagation()">
        Accept
      </button>
      <button *ngIf="!contact.canAccept && !contact.isaccepted" 
              class="status-pending">
        Pending
      </button>
    </div>
  </div>
</div>

        <!-- LIST VIEW -->
 <div *ngIf="viewMode === 'list'" class="doc-list-view">
  <table class="doc-table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email Address</th>
        <!-- <th>Status</th> -->
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let contact of list | filter:searchQuery" class="list-row-card">
        <td>
          <div class="doc-name-cell">
            <div class="listavatar" *ngIf="!contact.profile_url">
              {{ contact.business_name?.charAt(0).toUpperCase() }}
            </div>
            <img *ngIf="contact.profile_url" [src]="contact.profile_url" class="profile-img listimg"
                 (error)="contact.profile_url = null" />
            <span>{{ contact.business_name }}</span>
          </div>
        </td>
        <td>
          <span>{{ contact.email || '---' }}</span>
        </td>
        <!-- <td>
          <button *ngIf="contact.canAccept && !contact.isaccepted" class="status-accept"
            (click)="acceptRequest(contact.id, contact.biztype)">
            Accept
          </button>
          <button *ngIf="!contact.canAccept && !contact.isaccepted" class="status-pending">
            Pending
          </button>
          <button *ngIf="contact.status === 'accepted' || contact.status === 'accepted_by_consumer'"
            class="status-active-word">
            Active
          </button>
        </td> -->
        <td>
          <!-- Chat & Share shown directly as icon buttons -->
          <div class="list-action-icons">
            <button mat-icon-button
              class="list-action-btn"
              [disabled]="contact.status !== 'active' && contact.status !== 'accepted' && contact.status !== 'accepted_by_consumer'"
              (click)="goChatConnection($event, contact)"
              [matTooltip]="isLawyerInactive(contact) ? chatUnavailableMsg(contact) : 'Chat'">
              <i class="far fa-comment-dots"></i>
            </button>
            <button mat-icon-button
              class="list-action-btn"
              [disabled]="contact.status !== 'active' && contact.status !== 'accepted' && contact.status !== 'accepted_by_consumer'"
              (click)="goShareConnection($event, contact)"
              [matTooltip]="isLawyerInactive(contact) ? sharingDisabledMsg(contact) : 'Share'">
              <i class="far fa-share-square"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

      </ng-container>

      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="empty-state">
          <div class="upload-illustration">
            <img class="docimg" src="assets/images/ConnectionBB.png" alt="Add Connections">
          </div>
          <h3 class="emptyconn">No Connections Yet..</h3>
          <!-- <p class="exNetwork">Expand your network to stay connected with your digital relationships.</p>
          <button class="add-documents-btn" (click)="onAddConnection()">Add Connection</button> -->
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Address Book -->
  <div class="main-content goback" *ngIf="connectionKey">


    <div class="list-header lsh">
      <!-- <h2>Saved Contacts</h2> -->
      <h2 style="color: black;"><i class="fa fa-arrow-left" aria-hidden="true" (click)="goBack()"></i> &nbsp;
        Saved Contacts ({{ entity_list.length ?? 0 }})</h2>
      <!-- <h2>  </h2> -->
      <!-- Address Book and Add New are temporarily hidden -->
    </div>

    <!-- List Section -->
    <div class="document-list">
      <div class="search-section">
        <div class="search-container">
          <i class="material-icons">search</i>
          <input class="search-text" type="text" placeholder="Search for Contact..." [(ngModel)]="searchRel">
        </div>

        <!-- sort -->
        <div class="view-options">
          <button class="sort-btn" mat-raised-button [matMenuTriggerFor]="sortMenu">
            <i class="material-icons">sort</i>
          </button>

          <mat-menu #sortMenu="matMenu">
            <button *ngFor="let option of sortContacts" mat-menu-item (click)="option.action()">
              <i class="material-icons">{{option.icon}}</i>
              <span>{{ option.label }}</span>
            </button>
          </mat-menu>
        </div>
        <!-- sort -->

      </div>

      <!-- Display Contacts -->
      <ng-container *ngIf="entity_list.length; else noRelationshipsTemplate">

        <!-- Show Contact Cards -->
        <div class="contact-cards-container">
          <div class="contact-card" *ngFor="let contact of entity_list | filter:searchRel">
            <div class="avatar">
              {{ contact.name?.charAt(0).toUpperCase() }}
            </div>
            <div class="contact-details">
              <h4>{{ contact.name }}</h4>
              <p>{{ contact.email }}</p>
            </div>
            <div class="contact-actions">
              <button mat-icon-button (click)="onEditContact(contact)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="onDeleteContact(contact)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Empty State -->
      <ng-template #noRelationshipsTemplate>
        <div class="empty-state es2">
          <div class="upload-illustration">
            <img class="docimg" src="assets/images/addcontact.png" alt="Add Connections">
          </div>
          <h3 class="emptyconn">No Contact Saved Yet..</h3>
          <p class="exNetwork">Your saved contacts will be displayed here once added.</p>
          <button class="add-documents-btn" (click)="onAddContact()">Add Contact</button>
        </div>
      </ng-template>
    </div>

  </div>

  <!-- Profile Page -->
  <div class="main-content" *ngIf="profileKey">
    <div class="profile-container">

      <div class="profile-card">
        <h2 class="profile-title"> <img class="backo" (click)="goBacktoConnections()" src="assets/images/leftArrow.png">
          PROFILE</h2>

        <div class="profile-header">
          <!-- Show image if available, otherwise fallback avatar -->
          <ng-container *ngIf="selectedProfile?.profileUrl; else showInitial">
            <img [src]="selectedProfile.profileUrl" [alt]="selectedProfile.business_name" class="avatar" />
          </ng-container>

          <ng-template #showInitial>
            <div class="avatar-text">
              {{ selectedProfile?.business_name?.charAt(0).toUpperCase() }}
            </div>
          </ng-template>

          <div class="profile-info">
            <h2 class="name">{{ selectedProfile?.business_name }}</h2>
            <p class="email">{{ selectedProfile?.email }}</p>
            <a (click)="toggleDetails()" class="toggle-link">
              View details <i class="fa" [ngClass]="showDetails ? 'fa-angle-up' : 'fa-angle-down'"
                aria-hidden="true"></i>
            </a>
          </div>
        </div>

        <div class="details" *ngIf="showDetails">
          <div class="detail-row address-row">
            <i class="fas fa-map-marker-alt icon"></i>
            <div class="detail-label-group">
              <strong>Address:</strong>
              <p class="detail-value">{{ selectedProfile?.address || 'N/A' }}</p>
            </div>
          </div>
          <!-- <div class="detail-row">
            <i class="fas fa-th-large icon"></i>
            <div class="detail-label-group">
              <strong>Category:</strong>
              <p class="detail-value">{{ selectedProfile?.tags?.[0] === 'Lauditor' ? 'Lex-Z Lawyers' : (selectedProfile?.tags?.[0] || 'N/A') }}</p>
            </div>
          </div> -->
          <div class="detail-row">
            <i class="fas fa-globe icon"></i>
            <div class="detail-label-group">
              <strong>Country:</strong>

              <div class="country-display">
                <img [src]="getFlagUrl(selectedProfile?.country)" [alt]="selectedProfile?.country + ' Flag'"
                  class="flag-icon" *ngIf="getFlagUrl(selectedProfile?.country)" />
                <p class="detail-value">{{ selectedProfile?.country || 'N/A' }}</p>
              </div>

            </div>
          </div>
          <div class="detail-row">
            <i style="transform: rotateY(180deg);" class="fa fa-phone icon"></i>
            <div class="detail-label-group">
              <strong>Mobile:</strong>
              <p class="detail-value">{{ selectedProfile?.mobile || 'N/A' }}</p>
            </div>
          </div>
        </div>

      </div>

      <div class="shared-folder-card">
        <h2 class="section-title">
          <span class="title-text">SHARED FOLDER - DOCUMENTS</span>
          <span [matTooltip]="isLawyerInactive(selectedProfile) ? sharingDisabledMsg(selectedProfile) : ''" class="share-tip-wrap">
          <button class="add-new-btn" [disabled]="isLawyerInactive(selectedProfile)" (click)="shareDocuments()">
            <span class="btn-text">Share Documents <i class="far fa-share-square icon-btn2"></i></span>
          </button>
        </span>
        </h2>

        <!-- shared by me/with me-->
        <div class="tabs">
          <div class="tab" [class.active]="activeTab === 'with'" (click)="loadFiles('with')">
            Shared With Me ({{ filesSharedWith.length || 0 }})
          </div>

          <div class="tab" [class.active]="activeTab === 'by'" (click)="loadFiles('by')">
            Shared By Me ({{ filesSharedBy.length || 0 }})
          </div>
        </div>
        <!-- shared by me/with me-->

        <!-- Search Section -->
        <div class="search-section">
          <div class="search-container-share">
            <i class="material-icons">search</i>
            <input class="search-text" type="text" placeholder="Search for Document..." [(ngModel)]="searchQuery">
          </div>
        </div>
        <!-- Search Section -->

        <div style="overflow: scroll;height: 280px;">
          <div class="file-card" *ngFor="let file of files | filter:searchQuery">
            <div class="file-info">
              <img src="assets/images/file.svg" alt="Upload">
              <div>
                <div class="file-name">{{ getDoctypeName(file.docname) }}</div>
                <div class="file-desc">{{ file.description }}</div>
              </div>
            </div>
            <!-- <i class="fa fa-ellipsis-v more-icon"></i> -->

            <!-- Actions Column -->
            <button mat-icon-button [matMenuTriggerFor]="actionMenu" *ngIf="activeTab === 'with'">
              <i class="material-icons">more_vert</i>
            </button>
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="onDocumentAction('view', file)">
                <mat-icon>visibility</mat-icon>
                <span>View</span>
              </button>
              <button mat-menu-item (click)="onDocumentAction('download', file)">
                <mat-icon>download</mat-icon>
                <span>Download</span>
              </button>
              <!-- <button mat-menu-item (click)="onDocumentAction('delete', doc)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button> -->
            </mat-menu>

            <button *ngIf="activeTab === 'by'" class="unbtn" (click)="unshare(file)" title="Stop sharing this document">
              <i class="bi bi-x-circle unshare"></i>
            </button>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>


<!-- Document Preview Modal -->
<div *ngIf="isPreviewOpen" class="preview-modal">
  <div class="preview-content">
    <div class="preview-header">
      <h2>{{ previewDocument?.name }}</h2>
      <button mat-icon-button (click)="closePreview()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <div class="iframe-wrapper">
      <div *ngIf="isPreviewLoading" class="iframe-spinner-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading document preview...</p>
      </div>

      <ng-container *ngIf="!isPreviewLoading && previewDocument">
        <div class="preview-body">
          <iframe width="100%" height="100%" *ngIf="previewDocument.mimeType === 'application/pdf'"
            [src]="previewDocument.previewUrl" frameborder="0"></iframe>

          <img *ngIf="isImage(previewDocument.mimeType)" [src]="previewDocument.previewUrl"
            [alt]="previewDocument.name" class="preview-image" />

          <video *ngIf="isVideo(previewDocument.mimeType)" [src]="previewDocument.previewUrl" controls
            class="preview-video"></video>

          <!-- Default / Unsupported types -->
          <div *ngIf="!isImage(previewDocument.mimeType) && !isVideo(previewDocument.mimeType) && previewDocument.mimeType !== 'application/pdf'"
            class="no-preview">
            <img class="docmat" src="assets/images/docs.png" alt="document icon">
            <p>Preview not available for this file type</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<!-- Document Preview Modal -->